<!--  -->
<template>
    <div class="nav" :class="{vertical}">
        <slot></slot>
    </div>
</template>

<script>
import Vue from 'vue'
export default {
    name: 'g-nav',
    props: {
        value: {
            type: String,
            default: undefined
        },
        vertical: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            eventBus: new Vue()
        }
    },
    provide() {
        return {
            eventBus: this.eventBus,
            vertical: this.vertical
        }
    },
    mounted() {
        this.eventBus && this.eventBus.$emit('mountedSelect', this.value)
        this.listenItemClick()
    },
    methods: {
        listenItemClick() {
            this.eventBus && this.eventBus.$on('navItemClick', value => {
                this.$emit('input', value)
                this.eventBus.$emit('mountedSelect', value)
            })
        }
    }
}
</script>
<style scoped lang='scss'>
@import '../var';
.nav {
    display: inline-flex;
    border-bottom:1px solid $grey;
    color:$light-color;
    &.vertical{
        flex-direction: column;
        border:1px solid $grey;
    }
}
</style>